export default __webpack_public_path__ + "static/media/rnr-sports-table-18-cn.2836fd99.webp";